import React from "react";
import DeliveryQueuePage from "../DeliveryQueuePage";

// Delivery Queue — the console's landing view. All shipments, four queue tabs.
export default function LogisticsDeliveryQueuePage() {
    return <DeliveryQueuePage />;
}
